﻿import { Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { hasPermission, letterInString } from "@/services/Utils";
import { ESTATE_SINGULAR } from "@/services/estateLabels";
import { useOrderCreate } from "@/hooks/purchases/orders";

import classes from "./createOrder.module.scss";

const CreateOrderButton = ({ params, base, data, setData, save, approve, reject }) => {
	const navigate = useNavigate();
	const { addToast } = useToasts();

	const { data: response } = useOrderCreate(params);
	const { permissions } = response || {};

	const validSave = () => {
		if (!data.business_id) {
			addToast("Debe seleccionar razón social para continuar", {
				appearance: "error",
			});
			return false;
		}

		if (!data.estate_id) {
			addToast(`Debe seleccionar ${ESTATE_SINGULAR} para continuar`, {
				appearance: "error",
			});
			return false;
		}

		if (!data.dealer_id) {
			addToast("Debe seleccionar distribuidor para continuar", {
				appearance: "error",
			});
			return false;
		}

		if (!data.code_oc) {
			addToast("Debe ingresar número de OC para continuar", {
				appearance: "error",
			});
			return false;
		}

		if (!data.type_currency_id) {
			addToast("Debe seleccionar la moneda para continuar", {
				appearance: "error",
			});
			return false;
		}

		if (data && data.items.length === 0) {
			addToast("Debe ingresar el menos un producto para guardar", {
				appearance: "error",
			});
			return false;
		}

		let valid_item = true;
		let message = "";
		data.items.forEach((item, i) => {
			if (!item.product_id) {
				message = "Debe seleccionar un producto en todos los items";
				valid_item = false;
				return;
			}

			if (!item.container_content) {
				message = "Debe ingresar el contenido en todos los items";
				valid_item = false;
				return;
			}

			if (letterInString(".", item.container_content) > 1) {
				message = "Debe ingresar un formato válido en el campo contenido envase para el item" + (i + 1);
				valid_item = false;
				return;
			}

			if (!item.value_unit_measurement || !item.unit_measurement) {
				message = "Debe seleccionar la unidad de medida en todos los items";
				valid_item = false;
				return;
			}

			if (item.price_total) {
				if (!data.type_currency_id) {
					message = "Debe seleccionar el tipo de moneda";
					valid_item = false;
					return;
				}
			}
		});

		if (!valid_item) {
			addToast(message, {
				appearance: "error",
			});
			return false;
		}

		return true;
	};

	const handleSave = () => {
		if (validSave()) {
			data.items.map((item) => {
				if (!item.quantity) {
					item.quantity = 1;
				}
				return item;
			});

			save(
				{ params: data, base: base },
				{
					onSuccess: (_response) => {
						addToast("Orden de Compra guardada exitosamente", {
							appearance: "success",
						});

						navigate("/ordenes_compra");
					},
				},
			);
		}
	};

	const handleReject = () => {
		reject(
			{
				code: data.code_oc,
				base,
				element: data,
			},
			{
				onSuccess: (response) => {
					addToast(`OC rechazada correctamente.`, {
						appearance: "success",
					});

					if (response.order) {
						setData(response.order);
					}
				},
			},
		);
	};

	const handleApprove = () => {
		approve(
			{
				code: data.code_oc,
				base,
				element: data,
			},
			{
				onSuccess: (response) => {
					addToast(`OC aprobada correctamente.`, {
						appearance: "success",
					});

					if (response.order) {
						setData(response.order);
					}
				},
			},
		);
	};

	return (
		<Col md={12} className={classes.col_base}>
			<Col className={classes.buttons} md={12} xs={12}>
				<div className={classes.buttonClose}>
					<div onClick={() => (navigate(-1) ? navigate(-1) : navigate("/ordenes_compra"))}>CERRAR</div>
				</div>

				{data && data.state_id && Number(data.state_id) === 1 && data.order_id && hasPermission("approve", permissions) && (
					<div className={classes.buttonSave}>
						<div
							onClick={() => handleReject()}
							style={{
								backgroundColor: "#d77200",
							}}
						>
							RECHAZAR
						</div>
					</div>
				)}

				{data && data.state_id && Number(data.state_id) === 1 && data.order_id && hasPermission("approve", permissions) && (
					<div className={classes.buttonSave}>
						<div
							onClick={() => handleApprove()}
							style={{
								backgroundColor: "#7fb02f",
							}}
						>
							APROBAR
						</div>
					</div>
				)}

				{data &&
					data.state_id &&
					[1, 3].includes(Number(data.state_id)) &&
					(hasPermission("edit", permissions) || hasPermission("create", permissions)) && (
						<div className={`${classes.buttonSave} `}>
							<div onClick={() => handleSave()}>GUARDAR</div>
						</div>
					)}
			</Col>
		</Col>
	);
};

export default CreateOrderButton;
